<template>
  <div class="shop">
    <div class="container" v-show="loaded">
      <img
        class="bg"
        @load="bindLoadImage"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/adcef68c116b49355fa488501145d1b8.png"
        alt=""
      />
      <div
        class="btn-item"
        v-for="(item, index) in btnData"
        :key="index"
        :style="getStyle(item)"
      >
        <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
      </div>
      <div class="fixed-btn">
        <img
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a7f80dbc0f6d958be724e47e7def8519.png"
          alt=""
        />
        <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
      </div>
    </div>
    <AppLoading class="app-loading" v-if="!loaded" />
  </div>
</template>

<script>
import BetterweWxApi from '@/components/wx/control.js'
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
import AppLoading from '@/components/app/loading/loading.vue'
export default {
  components: { WxOpenLaunchApp, AppLoading },
  data() {
    return {
      loaded: false,
      extinfo:
        '/wmOtherPage?fromType=11&url=' +
        encodeURIComponent('http://t.weimob.com/DN_N4C8') +
        '&title=betterWE购物节',
      btnData: [
        {
          width: 375,
          height: 40,
          left: 0,
          top: 966
        },
        {
          width: 345,
          height: 367,
          left: 14,
          top: 1117
        },
        {
          width: 345,
          height: 422,
          left: 15,
          top: 1813
        },
        {
          width: 345,
          height: 840,
          left: 15,
          top: 2315
        },
        {
          width: 345,
          height: 795,
          left: 15,
          top: 3437
        },
        {
          width: 345,
          height: 795,
          left: 15,
          top: 4512
        },
        {
          width: 345,
          height: 505,
          left: 15,
          top: 5407
        },
        {
          width: 296,
          height: 48,
          left: 39,
          top: 5936
        }
      ]
    }
  },
  created() {},
  mounted() {
    this.setShareOptions()
  },
  methods: {
    getStyle(item) {
      let screenWidth = window.screen.width
      let designWidth = 375
      let res = {}
      for (let key in item) {
        res[key] = ((screenWidth * item[key]) / designWidth).toFixed(2) + 'px'
      }
      return res
    },
    bindLoadImage() {
      this.loaded = true
    },
    setShareOptions() {
      let shareOptions = {
        title: '年度冰点价💥betterWE购物节', // 分享标题
        desc: '全场每满300返40元现金✅上不封顶！', // 分享描述
        imgUrl:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c8aa4038aee40634c6ac8465122ed7e2.png' // 分享图标
      }
      BetterweWxApi.setShareData(shareOptions, shareOptions)
    }
  }
}
</script>
<style lang="scss" scoped>
.bg {
  width: 100%;
}
.fixed-btn {
  z-index: 2;
  position: fixed;
  bottom: 25px;
  left: 50%;
  transform: translate(-50%, 0%);
  width: 297px;
  img {
    width: 100%;
  }
}
.app-loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.container {
  position: relative;

  .btn-item {
    z-index: 1;
    position: absolute;
  }
}
</style>
